import { useCallback } from 'react'
import ModalSmallFilled from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { RowData } from '../../../../../../../../../../baseComponents/TwinTable/types'
import { TPVOrderData } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/types'
import twinFetchPost from '../../../../../../../../../../utils/globals/data'
import { SetEditDeleteModalTy } from '../../../../../../../../../../utils/hooks/useEditDeleteModal'
import useIsLoading from '../../../../../../../../../../utils/hooks/useIsLoading'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'


interface ModalProcessRegularizeSellTicketProps extends ModalProcessRegularizeSellTicketLogicProps {
}

const ModalProcessRegularizeSellTicket: React.FC<ModalProcessRegularizeSellTicketProps> = ({ setOpenModal, ...rest }) => {
    const { t } = useTwinTranslation()
    const { handleOnAccept, loading } = useModalProcessRegularizeSellTicketLogic({ setOpenModal, ...rest })
    return (
        <ModalSmallFilled opened={true} setOpened={() => { }} onClickOut={false} onAccept={handleOnAccept} onCancel={() => setOpenModal(null)} translations={{
            title: t('sureRegularizeSellTicket', '¿Seguro que quieres regularizar este ticket?'),
            subtitle: t('itChangePaymentMethodsOfThisTicket', 'Se cambiará el método de pago del ticket'),
            buttonAccept: t('accept', 'Aceptar')
        }} loading={loading} />
    )
}

interface ModalProcessRegularizeSellTicketLogicProps {
    allRowData?: RowData
    setOpenModal: SetEditDeleteModalTy
    url: string
    completeData: TPVOrderData
    onSubmit?: () => void
}

const useModalProcessRegularizeSellTicketLogic = ({ allRowData, url, setOpenModal, completeData, onSubmit }: ModalProcessRegularizeSellTicketLogicProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()

    const handleOnAccept = useCallback(async () => {
        startLoading?.()
        const res = await twinFetchPost(url, { ...allRowData?.values, id: completeData?.header?.id })
        if (res.status === 200) {
            setOpenModal({ type: 'delete', allRowData: { ...allRowData?.values, CurrencyId: allRowData?.CurrencyId, myTotalPayments: allRowData?.myTotalPayments, headerData: completeData?.header, OrderId: completeData?.header?.id, WarehouseId: allRowData?.WarehouseId, WorkingCenterId: allRowData?.WorkingCenterId } })
            onSubmit?.()
        } 
        endLoading?.()
    }, [allRowData, url, setOpenModal, startLoading, endLoading, completeData, onSubmit])
    return { handleOnAccept, loading }
}

export default ModalProcessRegularizeSellTicket